import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import routeEndpoints from 'route/endpoints';
import {
    getActiveSettingsSection,
    getVisibleSettingsSections,
} from 'views/V2/Settings/helper/utilities';

import styles from '../sidebar.module.css';

function SettingsSubNav({ adminType, user }) {
    const location = useLocation();
    const sections = getVisibleSettingsSections(adminType, user);
    const onSettings = location.pathname === routeEndpoints.settings;
    const activeKey = onSettings ? getActiveSettingsSection(sections, location.hash).key : null;

    return (
        <Box className={styles.subNav}>
            {sections.map((section) => (
                <NavLink
                    key={section.key}
                    to={{ pathname: routeEndpoints.settings, hash: section.key }}
                    isActive={() => section.key === activeKey}
                    className={styles.subNavItem}
                    activeClassName={styles.subNavItemActive}
                >
                    {section.label}
                </NavLink>
            ))}
        </Box>
    );
}

SettingsSubNav.propTypes = {
    adminType: PropTypes.string,
    user: PropTypes.object,
};

export default SettingsSubNav;
